import lottie from 'lottie-web';
import loadingJSON from '../constants/loading.json';
import { IS_RN } from '../constants';
import logger from '../lib/logger';
var elemMap = new Map();
var bodyElem;
export var showLoading = function (options) {
    var _a = options || {}, dom = _a.dom, loading = _a.loading;
    if (IS_RN) {
        logger.error('showLoading is not support RN Env');
        return;
    }
    if (!bodyElem)
        bodyElem = document.body;
    var currentElement = dom || bodyElem;
    var lastLoadingElem = elemMap.get(currentElement);
    if (lastLoadingElem)
        return;
    var loadingElement = document.createElement('div');
    loadingElement.setAttribute('style', "\n      position: absolute;\n      top: 0;\n      left: 0;\n      right: 0;\n      bottom: 0;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      z-index: 1000000;\n  ");
    if (loading) {
        loadingElement.appendChild(loading);
    }
    else {
        var iconElement = document.createElement('span');
        loadingElement.appendChild(iconElement);
        lottie.loadAnimation({
            container: iconElement,
            renderer: 'svg',
            loop: true,
            autoplay: true,
            animationData: loadingJSON,
        });
        iconElement.setAttribute('style', "\n        width: 92px;\n        height: 92px;\n        padding: 16px;\n        border-radius: 16px;\n        box-sizing: border-box;\n        background-color: rgba(107, 107, 107, 1);\n    ");
    }
    elemMap.set(currentElement, loadingElement);
    currentElement.appendChild(loadingElement);
};
export var hideLoading = function (options) {
    var dom = (options || {}).dom;
    var currentElement = dom || bodyElem;
    var loadingElement = elemMap.get(currentElement);
    if (!loadingElement)
        return;
    loadingElement.remove();
    elemMap.delete(currentElement);
};
